import { Component, DestroyRef, inject } from '@angular/core';
import { DocumentCommonService } from "@shared/services/documents-common.service";
import { FilesService } from "@shared/services/files.service";
import { ICellRendererParams } from "ag-grid-community";
import { BulkSignatoryGroup } from "@models/documents/sign-documents";
import { DocumentFileInfoShort } from '@models/ui-models/files';
import { DocumentSubFolderName } from '@models/common/document-sub-folder-name.enum';
import { ToastrService } from 'ngx-toastr';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FileLabelComponent } from "@shared/components/commons/file-label/file-label.component";

type CellRendererParams = ICellRendererParams<BulkSignatoryGroup>

@Component({
  selector: 'app-ag-documents-for-sign',
  standalone: true,
  imports: [FileLabelComponent],
  templateUrl: './ag-documents-for-sign.component.html',
  styleUrl: './ag-documents-for-sign.component.scss'
})

export class AgDocumentsForSignComponent implements ICellRendererAngularComp {
  protected params!: CellRendererParams;
  protected filesService = inject(FilesService);
  protected toastr = inject(ToastrService);
  destroyRef: DestroyRef = inject(DestroyRef);
  #documentCommonService = inject(DocumentCommonService);

  protected documentsForSign: DocumentFileInfoShort[] = [];

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.documentsForSign = params.data?.filesInfo ?? [];
    this.setRowHeight();
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    return true;
  }

  setRowHeight(): void {
    const rowHeight = 28;

    if (this.documentsForSign.length > 1) {
      const documentsForSignRowHeight = this.documentsForSign.length * rowHeight;
      this.params.node.setRowHeight(documentsForSignRowHeight);
      this.params.api.onRowHeightChanged();
    }
  }

  downloadFile(documentId: string, fileName: string): void {
    this.#documentCommonService.downloadFile(documentId, fileName, DocumentSubFolderName.Final);
  }
}
